'use client';


import UserDashboard from '@/components/dashboard/UserDashboard';

export default function Dashboard() {
  return (

    <UserDashboard />

  );
}
